export default "__VITE_ASSET__T4skIcw6__"